<template>

  <transition name="fade">
    <div v-show="showSuccessMessage" style="min-height: 300px">
      <h2 class="text-center mb-4">Thank you</h2>
      <p class="text-center mt-0 font-lato fs-16">
        Thank you for downloading Village Guide's media kit. If you have any<br class="d-none d-lg-block"> questions, please email
        <a href="mailto:info@villageguide.co.nz">info@villageguide.co.nz</a>.
      </p>
    </div>
  </transition>

  <div v-show="!showSuccessMessage">
    <h2 class="text-center mb-4">Download our media pack</h2>
    <p class="text-center mt-0 font-lato fs-16">
      To learn more about Village Guide and how we can support your retirement<br class="d-none d-lg-block"> village, download our 2023 media pack.
    </p>
    <Form
      :validation-schema="schema"
      v-slot="{ errors }"
      @submit="onSubmit"
      id="mediaKitForm"
      class="mr-auto ml-auto mt-8"
    >
      <slot name="token"></slot>
      <div class="form-group form-group--input">
        <label for="villageName" class="fs-16 font-weight-light-bold">Village name</label>
        <Field
          id="villageName"
          type="text"
          class="form-control fs-14"
          name="villageName"
          :class="{'is-danger': errors['villageName'] }"
        />
        <ErrorMessage name="villageName" class="is-danger" />
      </div>
      <div class="form-group form-group--input">
        <label for="name" class="fs-16 font-weight-light-bold">Your name</label>
        <Field
          id="name"
          type="name"
          class="form-control fs-14"
          name="name"
          :class="{'is-danger': errors['name'] }"
        />
        <ErrorMessage name="name" class="is-danger" />
      </div>
      <div class="form-group form-group--input">
        <label for="email" class="fs-16 font-weight-light-bold">Your email</label>
        <Field
          id="email"
          type="email"
          class="form-control ph-14 fs-14"
          name="email"
          :class="{'is-danger': errors['email'] }"
        />
        <ErrorMessage name="email" class="is-danger" />
      </div>
      <input type="hidden" name="captcha_action" value="learn_more">
      <transition name="fade">
        <div :class="confirmation.class" class="message" v-if="confirmation.show">{{ confirmation.message }}</div>
      </transition>
      <input type="submit" value="Submit" class="btn btn--green w-100 submit">
      <slot name="googlerecaptchatext"></slot>
    </Form>
  </div>
</template>

<script setup>
import {reactive, ref} from 'vue'
import axios from 'axios';
import {ErrorMessage, Field, Form} from 'vee-validate'
import {useFormSubmit} from '../../composables/useFormSubmit'

const { showServerSideValidateErrors } = useFormSubmit()
const props = defineProps({
  postUrl: {
    type: String,
    default: '',
  },
})

const confirmation = reactive({show: false, message: '', class: ''})
let isSubmitting = ref(false)
let showSuccessMessage = ref(false)

const schema = {
  villageName: 'required',
  name: 'required',
  email: 'required|email',
}

const onSubmit = async () => {
  isSubmitting.value = true
  confirmation.show = true
  confirmation.class = 'message--warning'
  confirmation.message = 'Submitting....'
  const form  = document.getElementById('mediaKitForm')
  let formData = new FormData(form);
  window.grecaptcha.execute(document.getElementById('mySiteKeyVariable').value, {
    action: formData.get('captcha_action'),
  }).then((token) => {
    const submitButton = form.querySelector('.submit');
    submitButton.disabled = true;
    formData.set('g-recaptcha-response', token);
    axios.post(props.postUrl, formData).then(function (response) {
      confirmation.class = 'message--success'
      confirmation.message = response.data.msg

      let currentUrl = window.location.href;
      history.pushState(null, null, `${currentUrl}#form-completed`);
      showSuccessMessage.value = true;
      setTimeout(function () {
        confirmation.show = false;
      }, 4000);

      Object.assign(document.createElement('a'), {
        target: '_blank',
        rel: 'noopener noreferrer',
        href: '/resources/Village_Guide_Subscriptions_Jan_2024.pdf',
      }).click();
    }).catch(error => {
      submitButton.disabled = false;
      showServerSideValidateErrors(error, isSubmitting, confirmation)
    });
  });
}

</script>
